import { ClerkProvider } from "@clerk/react"
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { getAuthConfig } from "./auth/config"

const rootEl = document.getElementById("root")
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl)
  const authConfig = getAuthConfig()
  root.render(
    <React.StrictMode>
      {authConfig.clerkPublishableKey ? (
        <ClerkProvider publishableKey={authConfig.clerkPublishableKey}>
          <App />
        </ClerkProvider>
      ) : (
        <App />
      )}
    </React.StrictMode>,
  )
}
